import { useSelector } from 'react-redux'

import { translator } from './selectors'

const useTranslator = () => useSelector(translator)

export {
  useTranslator
}
